/**
 * Native Google Tag Manager loader (APP-2232), replacing the direct
 * `react-ga4` integration. GTM owns the GA4 config tag from here on, so this
 * file's job is just getting the container loaded and the dataLayer primed --
 * everything downstream (which tags fire, on which events) lives in the GTM
 * container itself, not in this codebase.
 */

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

// Guards against a double `initGtm` call (e.g. React StrictMode / HMR)
// injecting the script twice, matching the `configured` flag pattern in
// components/auth/cognito/configureAmplify.ts.
let initialised = false;

/**
 * Boots GTM for `containerId`. A no-op when there is no container id to load
 * (see GTM_CONTAINER_ID in configuration.ts -- empty means "don't load"),
 * outside the browser, or if already initialised.
 */
export function initGtm(containerId: string): void {
  if (!containerId || typeof window === 'undefined' || initialised) return;
  initialised = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'gtm.js', 'gtm.start': Date.now() });

  const script = document.createElement('script');

  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(script);
}
